import { render, staticRenderFns } from "./HotSpotFeedback.vue?vue&type=template&id=66a0fd2a&scoped=true"
import script from "./HotSpotFeedback.vue?vue&type=script&lang=js"
export * from "./HotSpotFeedback.vue?vue&type=script&lang=js"
import style0 from "./HotSpotFeedback.vue?vue&type=style&index=0&id=66a0fd2a&prod&scoped=true&lang=scss"
import style1 from "./HotSpotFeedback.vue?vue&type=style&index=1&id=66a0fd2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0fd2a",
  null
  
)

export default component.exports